import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import EarningBreakdownTrend from '../../common/earningBreakdown/Trend'
import {
  getNoDataComponent,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

export const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = [
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA324'),
      color: '#006AA6',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA325'),
      color: '#74B49A',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA326'),
      color: '#B3CC85',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA344'),
      color: '#00A8B5',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA331'),
      color: '#0553A5',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA334'),
      color: '#4EB1CB',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA338'),
      color: '#1D5563',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA343'),
      color: '#F49966',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA327'),
      color: '#F5CBA3',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA328'),
      color: '#E3A2A7',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA329'),
      color: '#FF596A',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA330'),
      color: '#D96383',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA332'),
      color: '#FFCD60',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA335'),
      color: '#AE93E1',
      group: 2,
    },
    // {
    //   ...getValueAndTitleCheckbox(indicatorById, 'FA337'),
    //   color: '#717ECD',
    //   group: 2,
    // },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA342'),
      color: '#cc8b00',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA339'),
      color: '#902340',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA341'),
      color: '#D4A7D7',
      group: 3,
    },
  ]

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <EarningBreakdownTrend
      id={id}
      data={dataByTrend}
      indicatorById={indicatorById}
      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
      checkboxs={checkboxs.filter((item) => item.title)}
      checked={checked}
      setChecked={setChecked}
      isDynamicReport={isDynamicReport || isDownloadComponent}
    />
  )
}
